module.exports = __webpack_public_path__ + "static/media/Info_popup@3x.521335f5.png";